import React from 'react'
import { Box } from '@mui/material'
import loader from 'images/loader-ford.gif'

const Spinner = () => {
    return (
        <Box
            sx={{
                position: 'absolute',
                right: 0,
                bottom: 0,
                top: 0,
                left: 0,
                height: 400,
                zIndex: 3001
            }}
        >
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    top: 0,
                    left: 0,
                    zIndex: '-1'
                }}
            />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 25,
                    height: '100%'
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%'
                    }}
                >
                    <img src={loader} alt="loading.." />
                </Box>
            </Box>
        </Box>
    )
}

export default Spinner
